import React from 'react';

import ScreenSection from '../screen-section/ScreenSection';
import MainTitle from '../main-title/MainTitle';
import ContentContainer from '../content-container/ContentContainer';
import mapTransparentImage from '../../assets/images/map-transparent.svg';

import styles from './HeroScreen.module.scss';
import ScrollButton from './ScrollButton';

const HeroScreen = () => (
  <ScreenSection id="home" theme="dark" background={mapTransparentImage}>
    <div className={styles.root}>
      <div className={styles.centered}>
        <ContentContainer width="narrow">
          <span className={styles.subtitle}>Exclusive offer</span>
          <MainTitle>
            Real estate
            <br />
            free data
          </MainTitle>

          <div className={styles.descriptionHolder}>
            <p className={styles.description}>
              Possessing a unique expertise on sales / rent data in 30 countries of the world, we
              provide the service of creating infographics for your request
            </p>
          </div>
        </ContentContainer>
      </div>
    </div>

    <div className={styles.scrollButtonHolder}>
      <ScrollButton to="cooperation" href="#cooperation" />
    </div>
  </ScreenSection>
);

export default HeroScreen;
